// extracted by mini-css-extract-plugin
export default {"footer":"CopyRightFooter_footer__8YFqA"};